import { Coupon, Plan } from '../types';

const pixRates: Record<Plan, number> = {
  business: 3.49,
  lite: 5.19,
};

export const getPixRate = (plan: Plan, coupon?: Coupon) =>
  coupon && coupon?.valid && coupon?.pixRates
    ? coupon.pixRates[plan]
    : pixRates[plan];
